/** Tiny DOM helpers shared across ClientApp bundles (zero runtime deps). */
export function el<K extends keyof HTMLElementTagNameMap>(
    tag: K, attrs: Record<string, string | null | undefined> = {}, ...children: (Node | string)[]): HTMLElementTagNameMap[K] {
    const node = document.createElement(tag);
    for (const [k, v] of Object.entries(attrs)) {
        if (v == null) continue;
        if (k === 'class') node.setAttribute('class', v);
        else node.setAttribute(k, v);
    }
    for (const c of children) node.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
    return node;
}
